import { pieceReducer, type PieceAction } from './piece-reducer';
import type { PieceModel } from './types';

export interface PieceStore {
  getState: () => PieceModel;
  subscribe: (listener: () => void) => () => void;
  dispatch: (action: PieceAction) => void;
}

/**
 * Lightweight store for the editor model.
 * Kept outside React so updates can stay focused and avoid extra re-renders.
 */
export const createPieceStore = (initial: PieceModel): PieceStore => {
  let state = initial;
  const listeners = new Set<() => void>();

  return {
    getState: () => state,
    subscribe: listener => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    dispatch: action => {
      const next = pieceReducer(state, action);
      if (next === state) return;
      state = next;
      listeners.forEach(l => l());
    }
  };
};
